<template>
  <div>
    <IconButton
      icon="mdi-list-status"
      :tooltip-text="$t('serviceStatus.serviceStatus')"
      @click="showWindow = !showWindow"
    />
    
    <ServiceStatusWindow
      v-if="showWindow"
      @hideWindow="showWindow = false"
    />
  </div>
</template>

<script>
import IconButton from './IconButton.vue';
import ServiceStatusWindow from './ServiceStatusWindow.vue';

export default {
  name: 'ServiceStatusButton',
  components: {
    IconButton,
    ServiceStatusWindow
  },
  data() {
    return {
      showWindow: false
    };
  },

};
</script>
